var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteBlancBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88879 1C3.72511 1 3.56912 1.06442 3.45489 1.17751C3.34083 1.29043 3.27768 1.4425 3.27768 1.6V2.2H6.72213V1.6C6.72213 1.4425 6.65898 1.29043 6.54492 1.17751C6.43069 1.06442 6.27471 1 6.11102 1H3.88879ZM7.72213 2.2V1.6C7.72213 1.17402 7.55115 0.766519 7.24846 0.466857C6.94594 0.167363 6.5367 0 6.11102 0H3.88879C3.46311 0 3.05387 0.167363 2.75135 0.466857C2.44866 0.766519 2.27768 1.17402 2.27768 1.6V2.2H0.5C0.223858 2.2 0 2.42386 0 2.7C0 2.97614 0.223858 3.2 0.5 3.2H0.611017V10.4C0.611017 10.826 0.781992 11.2335 1.08468 11.5331C1.3872 11.8326 1.79645 12 2.22213 12H7.77769C8.20337 12 8.61261 11.8326 8.91513 11.5331C9.21782 11.2335 9.3888 10.826 9.3888 10.4V3.2H9.5C9.77614 3.2 10 2.97614 10 2.7C10 2.42386 9.77614 2.2 9.5 2.2H7.72213ZM1.61102 3.2V10.4C1.61102 10.5575 1.67417 10.7096 1.78823 10.8225C1.90245 10.9356 2.05844 11 2.22213 11H7.77769C7.94137 11 8.09736 10.9356 8.21159 10.8225C8.32564 10.7096 8.3888 10.5575 8.3888 10.4V3.2H1.61102Z",
    fill: "#5062F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBlancBlue);
export default __webpack_public_path__ + "static/media/deleteBlancBlue.6542ef4b6ef4e228276df157d07ee9db.svg";
export { ForwardRef as ReactComponent };